import { Translation } from '@ps/web-shared-components';
import type React from 'react';

import CardsImg from '../../../assets/cards.svg';
import {
  TXTCLI_Your_registered_and_active_gam_ELL,
  TXTWCL_No_Games_to_Show
} from '../../translations';

import styles from './NoGamesAvailable.module.scss';

const NoGamesAvailable: React.FC = () => (
  <div className={styles.wrap}>
    <CardsImg />
    <p className={styles.title}>
      <Translation {...TXTWCL_No_Games_to_Show} />
    </p>
    <p className={styles.description}>
      <Translation {...TXTCLI_Your_registered_and_active_gam_ELL} />
    </p>
  </div>
);

export default NoGamesAvailable;
